


















































































































































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { types } from '../../api_types';
import * as ui from '../../ui';
import T from '../../lang';

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

// Import Only Required Plugins
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  TabsPlugin,
  CardPlugin,
  DropdownPlugin,
  LayoutPlugin,
} from 'bootstrap-vue';
import ContestCard from './ContestCard.vue';
import infiniteScroll from 'vue-infinite-scroll';
Vue.use(TabsPlugin);
Vue.use(CardPlugin);
Vue.use(DropdownPlugin);
Vue.use(LayoutPlugin);
library.add(fas);

export enum ContestTab {
  Current = 'current',
  Future = 'future',
  Past = 'past',
}

export enum ContestOrder {
  None = 'none',
  Title = 'title',
  Ends = 'ends',
  Duration = 'duration',
  Organizer = 'organizer',
  Contestants = 'contestants',
  SignedUp = 'signedup',
}

export enum ContestFilter {
  SignedUp = 'signedup',
  OnlyRecommended = 'recommended',
  All = 'all',
}

export interface UrlParams {
  page: number;
  tab_name: ContestTab;
  query: string;
  sort_order: ContestOrder;
  filter: ContestFilter;
}

@Component({
  components: {
    'omegaup-contest-card': ContestCard,
    FontAwesomeIcon,
  },
  directives: {
    infiniteScroll,
  },
})
export default class ArenaContestList extends Vue {
  @Prop({ default: null }) countContests!: { [key: string]: number } | null;
  @Prop() contests!: types.ContestList;
  @Prop() query!: string;
  @Prop() tab!: ContestTab;
  @Prop({ default: ContestOrder.None }) sortOrder!: ContestOrder;
  @Prop({ default: ContestFilter.All }) filter!: ContestFilter;
  @Prop() page!: number;
  @Prop({ default: 10 }) pageSize!: number;
  @Prop({ default: false }) loading!: boolean;

  T = T;
  ui = ui;
  ContestTab = ContestTab;
  ContestOrder = ContestOrder;
  ContestFilter = ContestFilter;
  currentTab: ContestTab = this.tab;
  currentQuery: string = this.query;
  currentOrder: ContestOrder = this.sortOrder;
  currentFilter: ContestFilter = this.filter;
  currentPage: number = this.page;
  refreshing: boolean = false;
  isScrollLoading: boolean = false;
  hasMore: boolean = true;

  titleLinkClass(tab: ContestTab) {
    if (this.currentTab === tab) {
      return ['text-center', 'active-title-link'];
    } else {
      return ['text-center', 'title-link'];
    }
  }

  onSearchQuery() {
    const urlObj = new URL(window.location.href);
    const params: UrlParams = {
      page: 1,
      tab_name:
        (urlObj.searchParams.get('tab_name') as ContestTab) ||
        ContestTab.Current,
      query: this.currentQuery,
      sort_order:
        (urlObj.searchParams.get('sort_order') as ContestOrder) ||
        ContestOrder.None,
      filter:
        (urlObj.searchParams.get('filter') as ContestFilter) ||
        ContestFilter.All,
    };
    this.currentPage = 1;
    this.hasMore = true;
    this.fetchPage(params, urlObj);
  }
  onReset() {
    this.currentQuery = '';
  }
  fetchInitialContests() {
    const urlObj = new URL(window.location.href);
    const params: UrlParams = {
      page: 1,
      tab_name: this.currentTab,
      query: this.currentQuery,
      sort_order: this.currentOrder,
      filter: this.currentFilter,
    };
    // Reset the contest list for this tab to avoid stale data
    Vue.set(this.contests, this.currentTab, []);
    this.currentPage = 1;
    this.hasMore = true;
    this.fetchPage(params, urlObj);
  }
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.fetchInitialContests();
  }

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    const bottomOfWindow =
      window.innerHeight + window.scrollY >=
      document.documentElement.scrollHeight - 250;

    if (
      !this.contestListEmpty &&
      bottomOfWindow &&
      !this.isScrollLoading &&
      this.hasMore
    ) {
      this.loadMoreContests();
    }
  }
  async loadMoreContests() {
    if (this.isScrollLoading || !this.hasMore) return;

    this.isScrollLoading = true;
    const nextPage = this.currentPage + 1;
    const urlObj = new URL(window.location.href);
    const params: UrlParams = {
      page: nextPage,
      tab_name: this.currentTab,
      query: this.currentQuery,
      sort_order: this.currentOrder,
      filter: this.currentFilter,
    };

    try {
      await this.fetchPage(params, urlObj);
      this.currentPage = nextPage;

      // Check if there are more contests to load (based on pageSize)
      this.hasMore = this.contestList.length % this.pageSize === 0;
    } finally {
      this.isScrollLoading = false;
    }
  }

  fetchPage(params: UrlParams, urlObj: URL) {
    this.$emit('fetch-page', { params, urlObj });
    // Turn off refreshing after a short delay to allow parent component to respond
    setTimeout(() => {
      this.refreshing = false;
    }, 1000);
  }

  finishContestDate(contest: types.ContestListItem): string {
    return contest.finish_time.toLocaleDateString();
  }

  startContestDate(contest: types.ContestListItem): string {
    return contest.start_time.toLocaleDateString();
  }

  getTimeLink(time: Date): string {
    return `http://timeanddate.com/worldclock/fixedtime.html?iso=${time.toISOString()}`;
  }

  orderByTitle() {
    this.currentOrder = ContestOrder.Title;
  }

  orderByEnds() {
    this.currentOrder = ContestOrder.Ends;
  }

  orderByDuration() {
    this.currentOrder = ContestOrder.Duration;
  }

  orderByOrganizer() {
    this.currentOrder = ContestOrder.Organizer;
  }

  orderByContestants() {
    this.currentOrder = ContestOrder.Contestants;
  }

  orderBySignedUp() {
    this.currentOrder = ContestOrder.SignedUp;
  }

  filterBySignedUp() {
    this.currentFilter = ContestFilter.SignedUp;
  }
  filterByRecommended() {
    this.currentFilter = ContestFilter.OnlyRecommended;
  }
  filterByAll() {
    this.currentFilter = ContestFilter.All;
  }

  get contestList(): types.ContestListItem[] {
    switch (this.currentTab) {
      case ContestTab.Current:
        return this.contests.current;
      case ContestTab.Past:
        return this.contests.past;
      case ContestTab.Future:
        return this.contests.future;
      default:
        return this.contests.current;
    }
  }

  get contestListEmpty(): boolean {
    if (!this.contestList) return true;
    return this.contestList.length === 0;
  }
  @Watch('currentTab', { immediate: true, deep: true })
  onCurrentTabChanged(newValue: ContestTab, oldValue: undefined | ContestTab) {
    if (typeof oldValue === 'undefined') return;
    this.fetchInitialContests();
  }

  @Watch('currentOrder', { immediate: true, deep: true })
  onCurrentOrderChanged(
    newValue: ContestOrder,
    oldValue: undefined | ContestOrder,
  ) {
    if (typeof oldValue === 'undefined') return;
    this.fetchInitialContests();
  }

  @Watch('currentFilter', { immediate: true, deep: true })
  onCurrentFilterChanged(
    newValue: ContestFilter,
    oldValue: undefined | ContestFilter,
  ) {
    if (typeof oldValue === 'undefined') return;
    this.fetchInitialContests();
  }
}
